import resolveResponse from 'contentful-resolve-response'
import fetchQueryWrapper from '../../network/fetchQueryWrapper'
import { CONTENT_TYPE } from '../../utils/contentTypes'
import getStoryBySlug from '../../utils/getStoryBySlug'
import logger from '../../utils/winston-logger/winston-logger'
import extractBanner from '../../data/transformers/extractBreakingNewsBanner'
import extractStoryPage from '../../data/transformers/extractStoryPage'
import StoryDetails from '../../components/Story/StoryDetails'

const Media = ({ data, banner }) => <StoryDetails story={data.story} metadata={data.metadata} banner={banner} />

export async function getServerSideProps(ctx) {
  try {
    const storyPageData = await getStoryBySlug(ctx.query.slug)

    if (!storyPageData) {
      return { notFound: true }
    }

    const breakingNewsBannerData = await fetchQueryWrapper(
      {
        content_type: CONTENT_TYPE.BANNER,
        order: '-sys.updatedAt'
      },
      resolveResponse
    )

    return {
      props: {
        data: extractStoryPage(storyPageData),
        banner: extractBanner(breakingNewsBannerData)
      }
    }
  } catch (error) {
    logger.error('Error in media/[slug].page.js ', error)
    return { notFound: true }
  }
}

export default Media
